var allDetails = document.querySelectorAll('details');
allDetails.forEach((detail) => {
    detail.addEventListener('toggle', function() {
        // Check if the current details is being opened
        if (this.open) {
            // Close all other details elements
            allDetails.forEach((otherDetail) => {
                if (otherDetail !== this) {
                    otherDetail.open = false;
                }
            });
          toggleImages(this.getAttribute("block_id"));
        }
    });
});

function toggleImages(block_id) {
  var images = document.querySelectorAll(".collapsible-content__media");
  images.forEach((img) => {
    let img_block_id = img.getAttribute("block_id");
    img.style.display = img_block_id == block_id ? "block" : "none";
  });
}
